module.exports = __webpack_public_path__ + "static/media/logo-natural-stone.aacde71d.svg";